export class Souscription {
  civiliteSouscripteur!: string;
  nomSouscripteur!: string;
  prenomSouscripteur!: string;
  nomNaissanceSouscripteur!: string;
  dateNaissanceSouscripteur!: Date;
  professionSouscripteur!: string;
  situationSouscripteur!: string;
  adresseSouscripteur: string = '';
  adresseComplementSouscripteur!: string;
  codePostalSouscripteur!: string;
  ville!: string;
  mailSouscripteur!: string;
  telMobileSouscripteur!: string;
  telFixeSouscripteur!: string;
  bAccepteCondition!: boolean;
  telaRappeler!: string;
  eMailRecontacte!: string;
  paysNaissanceSouscripteur!: string;
  lieuNaissanceSouscripteur!: string;
  codeParrain!: string;
  adresse1Parrain!: string | null;
  adresse2Parrain!: string | null;
  cspSouscripteur!: string | null;
  cspConjointSouscripteur!: string | null;
  constructor(
    civiliteSouscripteur: string,
    nomSouscripteur: string,
    prenomSouscripteur: string,
    nomNaissanceSouscripteur: string,
    dateNaissanceSouscripteur: Date,
    professionSouscripteur: string,
    situationSouscripteur: string,
    adresseSouscripteur: string,
    adresseComplementSouscripteur: string,
    codePostalSouscripteur: string,
    ville: string,
    mailSouscripteur: string,
    telMobileSouscripteur: string,
    telFixeSouscripteur: string,
    bAccepteCondition: boolean,
    telaRappeler: string,
    eMailRecontacte: string,
    paysNaissanceSouscripteur: string,
    lieuNaissanceSouscripteur: string,
    codeParrain: string = '',
    Adresse1Parrain: string | null = null,
    Adresse2Parrain: string | null = null,
    cspSouscripteur: string | null = null,
    cspConjointSouscripteur: string | null = null,
  ) {
    this.civiliteSouscripteur = civiliteSouscripteur;
    this.nomSouscripteur = nomSouscripteur;
    this.prenomSouscripteur = prenomSouscripteur;
    this.nomNaissanceSouscripteur = nomNaissanceSouscripteur;
    this.dateNaissanceSouscripteur = dateNaissanceSouscripteur;
    this.professionSouscripteur = professionSouscripteur;
    this.situationSouscripteur = situationSouscripteur;
    this.adresseSouscripteur = adresseSouscripteur;
    this.adresseComplementSouscripteur = adresseComplementSouscripteur;
    this.codePostalSouscripteur = codePostalSouscripteur;
    this.ville = ville;
    this.mailSouscripteur = mailSouscripteur;
    this.telMobileSouscripteur = telMobileSouscripteur;
    this.telFixeSouscripteur = telFixeSouscripteur;
    this.bAccepteCondition = bAccepteCondition;
    this.telaRappeler = telaRappeler;
    this.eMailRecontacte = eMailRecontacte;
    this.paysNaissanceSouscripteur = paysNaissanceSouscripteur;
    this.lieuNaissanceSouscripteur = lieuNaissanceSouscripteur;
    this.codeParrain = codeParrain;
    this.adresse1Parrain = Adresse1Parrain;
    this.adresse2Parrain = Adresse2Parrain;
    this.cspSouscripteur = cspSouscripteur;
    this.cspConjointSouscripteur = cspConjointSouscripteur;

    if (
      this.cspSouscripteur == '' ||
      this.cspSouscripteur == null ||
      this.cspSouscripteur == 'null'
    ) {
      this.cspSouscripteur = '0';
    }
    if (
      this.cspConjointSouscripteur == '' ||
      this.cspConjointSouscripteur == null ||
      this.cspConjointSouscripteur == 'null'
    ) {
      this.cspConjointSouscripteur = '0';
    }
  }
}
